import { ClientProxy } from '../../base/proxy/clientProxy'

/** Bayinin görmediği admin dönüşü (Faz-37 §3). Bayi/kullanıcı kimliği GÖNDERİLMEZ — oturumdan çözülür. */
export interface IFeedbackReply {
  ReplyId: number
  Title: string
  Html: string
}

/** Sunucu en fazla 5 döner; istemci de bu sınırı korur. */
export const MAX_PENDING_REPLIES = 5

/** Biçimi bozuk öğe sessizce atlanır; liste değilse boş liste (popup gösterilmez). */
export const normalizePendingReplies = (raw: unknown): IFeedbackReply[] => {
  if (!Array.isArray(raw)) return []
  return raw
    .filter(
      (item): item is IFeedbackReply =>
        !!item &&
        typeof item === 'object' &&
        Number.isFinite(Number((item as IFeedbackReply).ReplyId)) &&
        typeof (item as IFeedbackReply).Title === 'string' &&
        typeof (item as IFeedbackReply).Html === 'string' &&
        (item as IFeedbackReply).Title.trim().length > 0
    )
    .map(item => ({ ReplyId: Number(item.ReplyId), Title: item.Title, Html: item.Html }))
    .slice(0, MAX_PENDING_REPLIES)
}

const isOkPseudoError = (error: unknown): boolean =>
  !!error &&
  typeof error === 'object' &&
  (error as { description?: unknown }).description === 'OK' &&
  (error as { success?: unknown }).success !== false

export class FeedbackRepliesPendingApi extends ClientProxy {
  constructor() {
    super({ url: 'chat/feedback-replies/pending' })
  }

  public async list(): Promise<IFeedbackReply[]> {
    return normalizePendingReplies(await this.getAsync<unknown>())
  }
}

/** Görüldü kaydı: sunucuda kullanıcı başına tek satır; tekrar yazılmaz. */
export class FeedbackReplySeenApi extends ClientProxy {
  constructor(replyId: number) {
    super({ url: `chat/feedback-replies/${encodeURIComponent(String(replyId))}/seen` })
  }

  public async markSeen(): Promise<void> {
    try {
      await this.postAsync<unknown>()
    } catch (error) {
      // Gövdesiz başarılı yanıt (Data = null, Message = "OK") ClientProxy'de hata olarak fırlar.
      if (isOkPseudoError(error)) return
      throw error
    }
  }
}
